// Preferences.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Preferences() {
    return (
        <PageLayout title="Preferences" subtitle="Preferences overview">
            <div className="container flex col box-container">
                {/* <div className="box">Preferences</div> */}
            </div>
        </PageLayout>   
    );
}

export default Preferences;
